<script lang="ts">
	import type { RichTextSegment } from "./glossary.types";
	import GlossaryTerm from "./glossary-term.svelte";

	interface Props {
		segments: RichTextSegment[];
	}

	let { segments }: Props = $props();
</script>

{#each segments as segment, index (index)}{#if "term" in segment}<GlossaryTerm
			term={segment.term}
			text={segment.text}
		/>{:else}{segment.text}{/if}{/each}
